import { atom } from "recoil";

export const SelfSignSuccessState = atom<boolean>({
    key: "self-sign-success-state-key",
    default: false
})